import React, { useEffect, useState } from 'react'

import { get, post } from '../../config/fetch'

import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { Phone } from '@material-ui/icons'

import Total from './total'
import RadialBar from './radialbar'
import BarIncidents from './barincidents'
import ProgressBar from './progressbar'
import { green } from '@material-ui/core/colors'
import CircularProgress from '@material-ui/core/CircularProgress'
import BarHorizontal from '../dashboard/barhorizontal'
import BarTopIncidents from './bartopincidents'
import LineIncidents from './lineincidents'
import { Accordion, Tooltip } from '@material-ui/core'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Typography from '@material-ui/core/Typography'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import DateFnsUtils from '@date-io/date-fns'
import { KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import RadialIncidents from './radialIncidents'
import BarTimeApps from './bartimeapps'
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import IconButton from '@material-ui/core/IconButton'
import CreateIcon from '@material-ui/icons/Create'
import DeleteIcon from '@material-ui/icons/Delete'
import TableHead from '@material-ui/core/TableHead'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { TOKEN_GET_DEVICES_BRAND, TOKEN_GET_DEVICES_LIST, TOKEN_INCIDENTS_BY_DATE } from '../../constants/constants'

const drawerWidth = 240
const MILLISECONDS = 60000;
const MILLISECONDS_HOURS = 3600000;
const MINUTES = 60;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        background: 'black'
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        magin: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        backgroundColor: '#06171E',
    },
    paper2: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    fixedHeight: {
        height: 600,
    },
    fixedHeight2: {
        height: 135,
    },
    fixedHeight3: {
        height: 450,
    },
}))

const columns = [
    { id: 'nameApp', disablePadding: false, label: 'Name App' },
    { id: 'devices', disablePadding: false, label: 'Devices' },
    { id: 'time', disablePadding: false, label: 'Total time' },
    { id: 'min', disablePadding: false, label: 'Min time' },
    { id: 'max', disablePadding: false, label: 'Max time' },
    { id: 'avg', disablePadding: false, label: 'Avg time' },
]

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props
    const createSortHandler = property => event => {
        onRequestSort(event, property)
    }

    return (
        <TableHead>
            <TableRow>
                {columns.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align || 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1
    }
    if (b[orderBy] > a[orderBy]) {
        return 1
    }
    return 0
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0])
        if (order !== 0) return order
        return a[1] - b[1]
    })
    return stabilizedThis.map(el => el[0])
}

export default function UseAppsKpi() {
    const classes = useStyles()
    const today = new Date()
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
    const fixedHeightPaper2 = clsx(classes.paper, classes.fixedHeight2)
    const fixedHeightPaper3 = clsx(classes.paper, classes.fixedHeight)

    const [totalApps, setTotalApps] = useState(0)
    const [totalDevices, setTotalDevices] = useState(0)
    const [totalTime, setTotalTime] = useState('')
    const [totalAverage, setTotalAverage] = useState('')

    const [totalAppsData, setTotalAppsData] = useState([])
    const [topAppsData, setTopAppsData] = useState([])
    const [nameAppsData, setNameApps] = useState([])
    const [detailUseAppsData, setDetailUseAppsData] = useState([])

    const [order, setOrder] = useState('asc')
    const [orderBy, setOrderBy] = useState('calories')
    const [selected, setSelected] = useState([])
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(50)
    
    
    const [dashboardData, setDashboardData] = useState()
    const [dashboardNetData, setDashboardNetData] = useState()
    const [noIncidentsNetData, setNoIncidentsNetData] = useState()

    const [incidentsDayData, setIncidentsDayData] = useState()
    const [incidentsNetDayData, setIncidentsNetDayData] = useState()

    const [topIncidentsRSSIData, setTopIncidentsRSSIData] = useState()
    const [topIncidentsRSRQData, setTopIncidentsRSRQData] = useState()
    const [topIncidentsRSRPData, setTopIncidentsRSRPData] = useState()
    const [topIncidentsRoamingData, setTopIncidentsRoamingData] = useState()
    const [topIncidentsVolteData, setTopIncidentsVolteData] = useState()
    const [topIncidentsMobileData, setTopIncidentsMobileData] = useState()
    const [topIncidentsBatteryData, setTopIncidentsBatteryData] = useState()

    const [incidentType, setIncidentType] = useState('user')
    const [devicesBrand, setDevicesBrand] = useState()
    const [devicesList, setDevicesList] = useState()
    const [startDate, setStartDate] = useState(
        new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0),
    )
    const [endDate, setEndDate] = useState(
        new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59),
    )

    const [deviceIdBrand, setDeviceIdBrand] = useState('')
    const [deviceIdList, setDeviceIdList] = useState('')
    const [columsGrid, setColumnsGrid] = useState(12)
    
    const [isLoading, setLoading] = useState(true)
    const [isLoadingByDate, setLoadingByDate] = useState(true)
    const [visiblePopover, setVisiblePopover] = useState(false)

    const fetchDevicesBrand = async () => {
        try {
            const response = await get(
                `/devicesBrand?code=${TOKEN_GET_DEVICES_BRAND}`,
            )
            setDevicesBrand(response.data);
        } catch (e) {
            throw new Error(e)
        }
    }

    const fetchDevicesList = async () => {
        try {
            const response = await get(
                `/devicesList?code=${TOKEN_GET_DEVICES_LIST}`,
            )
            setDevicesList(response.data);
        } catch (e) {
            throw new Error(e)
        }
    }

    const fetchUseAppsKpi = async (startD, endD, devicesIdL, deviceIdB) => {
        try {
            //setLoading(true)
            const response = await get(
                `/useAppKpi?startDate=${startD}&endDate=${endD}&deviceIdList=${devicesIdL || ''}&deviceIdBrand=${deviceIdB || ''}`,
            )
            dataUseApps(response.data)
            //setLoading(false)
        } catch (e) {
            throw new Error(e)
        }
    }
    

    const fetchDashboardData = async (startD, endD, devicesIdL, deviceIdB) => {
        try {
            //setLoading(true)
            const response = await get(
                `/incidentsKpi?code=KcgCgyjPxDll6cpCvJbvJpMoWdFuh93YVu/oq5sVJ0AlwK3PanfR/Q==&startDate=${startD}&endDate=${endD}&deviceIdList=${devicesIdL || ''}&deviceIdBrand=${deviceIdB || ''}`,
            )
            //setDashboardData(response.data)
            //setLoading(false)
            categoriesIncidentsUser(response.data);
        } catch (e) {
            throw new Error(e)
        }
    }

    const fetchDashboardNetData = async (startD, endD, devicesIdL, deviceIdB) => {
        try {
            setLoading(true)
            const response = await get(
                `/incidentsNetwork?startDate=${startD}&endDate=${endD}&deviceIdList=${devicesIdL || ''}&deviceIdBrand=${deviceIdB || ''}`,
            )
            //setDashboardNetData(response.data)
            setLoading(false)
            categoriesIncidents(response.data);
            //return response.data;
        } catch (e) {
            throw new Error(e)
        }
    }

    const fetchIncidentsDayData = async data => {
        try {
            setLoadingByDate(true)
            const response = await get(
                `/incidentsByDate?code=${TOKEN_INCIDENTS_BY_DATE}`,
            )
            setIncidentsDayData(response.data)
            setLoadingByDate(false)
        } catch (e) {
            throw new Error(e)
        }
    }

    const fetchIncidentsNetDayData = async data => {
        try {
            setLoadingByDate(true)
            const response = await get(
                `/incidentsNetByDate?code=cgTouy6yx4t/uWh4Nf5HU71eDG7Y8yrwf3pDPdMDxLHOHdsvapS/dQ==`,
            )
            setIncidentsNetDayData(response.data)
            setLoadingByDate(false)
        } catch (e) {
            throw new Error(e)
        }
    }

    /*
    useEffect(() => {
        //setLoading(true)
        fetchDevicesBrand();
    });

    useEffect(() => {
        fetchDevicesList();
    });
    */

    useEffect( async () => {
        setLoading(true)
        await fetchDevicesBrand();
        await fetchDevicesList();

        const startD = new Date(2022, 0, 21, 0, 0);

        await fetchUseAppsKpi(startDate, endDate, deviceIdList, deviceIdBrand);
        setLoading(false)

        //setDashboardNetData([0, 0, 0]);
        //setNoIncidentsNetData([0, 0, 0]);
        //setDashboardData([0, 0, 0, 0]);
        //setLoading(false)
        //setIncidentType('network');
        //fetchDashboardData();
        //fetchIncidentsDayData();
        //fetchIncidentsNetDayData();
        //fetchDashboardData(startDate, endDate, deviceIdList, deviceIdBrand);
        //await categoriesIncidents();
        //fetchDashboardNetData(deviceIdBrand);
    }, []);

    const dataUseApps = (useAppsItems) => {
        let countApps = 0;
        let countTime = 0;
        let average = 0;
        let devicesCount = 0;
        let arrNameApps = [];
        let arrDetailApps = [];
        let arrTotalUseApps = [];
        let arrTopUseApps = [];
        let otherNameApp = "";
        let otherTimeApp = 0;

        if (useAppsItems.countDevices && useAppsItems.countDevices.length > 0) {
            devicesCount = useAppsItems.countDevices[0].countDevices
        }
        
        if (useAppsItems.kpi && useAppsItems.kpi.length > 0) {
            useAppsItems.kpi.sort((a, b) => b.totalTime - a.totalTime);

            useAppsItems.kpi.forEach(item => {
                countApps++;
                countTime += (item.totalTime / MILLISECONDS);
                if (countApps > 9) {
                    otherTimeApp += (item.totalTime / MILLISECONDS)
                } else {
                    arrNameApps.push(item.nameApp)
                    arrDetailApps.push((item.totalTime / MILLISECONDS).toFixed(2))
                    arrTotalUseApps.push({
                        name: item.nameApp,
                        data: [item.totalTime / MILLISECONDS]
                    })
                }
                if (countApps <= 50) {
                    arrTopUseApps.push(item)
                }
            });
            arrNameApps.push('Others')
            arrDetailApps.push(otherTimeApp.toFixed(2))
            arrTotalUseApps.push({
                name: 'Others',
                data: [otherTimeApp]
            })
            
            if (countTime > MINUTES) {
                setTotalTime((countTime / MINUTES).toFixed(2) + ' h' )
            } else {
                setTotalTime(countTime.toFixed(2) + ' m' )
            }
            
            if (countApps !== 0) {
                average = countTime / countApps;
                if (average > MINUTES) {
                    setTotalAverage((countTime / MINUTES).toFixed(2) + ' h' )
                } else {
                    setTotalAverage(average.toFixed(2) + ' m' )
                }
            }
            
            if (arrTotalUseApps.length > 0) {
                arrTotalUseApps.sort((a, b) => b.data[0] - a.data[0]);

                arrNameApps = arrTotalUseApps.map(value => value.name);
                arrDetailApps = arrTotalUseApps.map(value => value.data[0].toFixed(2));
            }
            
            arrTopUseApps.map(value => {
                value.avgTime = (value.avgTime / MILLISECONDS)
                value.maxTime = (value.maxTime / MILLISECONDS)
                value.minTime = (value.minTime / MILLISECONDS)
                value.totalTime = (value.totalTime / MILLISECONDS)
                value.countDevices = value.countDevices > devicesCount ? devicesCount : value.countDevices
            });
            
            /*
            const totalUse = useAppsItems.kpi.map((item, key) => {
                return {
                    name: item.nameApp,
                    data: [item.totalTime / MILLISECONDS]
                }
            });
            */

            setTotalApps(countApps)
            setTotalDevices(devicesCount)
            setTotalAppsData(arrTotalUseApps)
            setDetailUseAppsData(arrDetailApps)
            setNameApps(arrNameApps)
            setTopAppsData(arrTopUseApps)
        } else {
            setTotalApps(0)
            setTotalDevices(0)
            setTotalTime('0 m')
            setTotalAverage('0 m')
            setTotalAppsData(arrTotalUseApps)
            setDetailUseAppsData(arrDetailApps)
            setNameApps(arrNameApps)
        }
    }
    
    const categoriesIncidents = (incidentsNet) => {
        let dataCategories = [0, 0, 0];
        let dataCategoriesNoInc = [0, 0, 0];
        let topRSSI = [];
        let topRSRQ = [];
        let topRSRP = [];
        //const incidentsNet = await fetchDashboardNetData();

        const incidentsRSSI = incidentsNet.incidentsKpi.filter(r => r.type === "RSSI")[0].incidents;
        const incidentsRSRQ = incidentsNet.incidentsKpi.filter(r => r.type === "RSRQ")[0].incidents;
        const incidentsRSRP = incidentsNet.incidentsKpi.filter(r => r.type === "RSRP")[0].incidents;

        incidentsRSSI.forEach(value => {
            dataCategories[0] += value.countIncident;
        });
        incidentsRSRQ.forEach(value => {
            dataCategories[1] += value.countIncident;
        });
        incidentsRSRP.forEach(value => {
            dataCategories[2] += value.countIncident;
        });

        incidentsRSSI.sort((a, b) => b.countIncident - a.countIncident);
        incidentsRSRQ.sort((a, b) => b.countIncident - a.countIncident);
        incidentsRSRP.sort((a, b) => b.countIncident - a.countIncident);
        
        let length = incidentsRSSI.length >= 5 ? 5 : incidentsRSSI.length;
        for (let i = 0; i < length; i++) {
            topRSSI.push({ name: incidentsRSSI[i].deviceId, value: incidentsRSSI[i].countIncident });
        }
        length = incidentsRSRQ.length >= 5 ? 5 : incidentsRSRQ.length;
        for (let i = 0; i < length; i++) {
            topRSRQ.push({ name: incidentsRSRQ[i].deviceId, value: incidentsRSRQ[i].countIncident });
        }
        length = incidentsRSRP.length >= 5 ? 5 : incidentsRSRP.length;
        for (let i = 0; i < length; i++) {
            topRSRP.push({ name: incidentsRSRP[i].deviceId, value: incidentsRSRP[i].countIncident });
        }

        //this.ramps.sort((a, b) => this.sortTypeId === 1 ? a.number - b.number : b.number - a.number);
        
        const noIncidentsRSSI = incidentsNet.noIncidentsKpi.filter(r => r.type === "RSSI")[0].incidents[0].countNoIncident;
        const noIncidentsRSRQ = incidentsNet.noIncidentsKpi.filter(r => r.type === "RSRQ")[0].incidents[0].countNoIncident;
        const noIncidentsRSRP = incidentsNet.noIncidentsKpi.filter(r => r.type === "RSRP")[0].incidents[0].countNoIncident;
        
        dataCategoriesNoInc[0] = noIncidentsRSSI;
        dataCategoriesNoInc[1] = noIncidentsRSRQ;
        dataCategoriesNoInc[2] = noIncidentsRSRP;
        
        setDashboardNetData(dataCategories);
        setNoIncidentsNetData(dataCategoriesNoInc);
        
        setTopIncidentsRSSIData(topRSSI);
        setTopIncidentsRSRQData(topRSRQ);
        setTopIncidentsRSRPData(topRSRP);

        setLoading(false)
    }

    const categoriesIncidentsUser = (incidentsUser) => {
        let dataCategories = [0, 0, 0, 0];
        let topRoaming = [];
        let topVolte = [];
        let topMobile = [];
        let topBattery = [];
        //const incidentsNet = await fetchDashboardNetData();
        console.log('incidentsUser: ', incidentsUser);

        const incidentsRoaming = incidentsUser.incidentsKpi.filter(r => r.type === "Roaming")[0].incidents;
        const incidentsVoLTE = incidentsUser.incidentsKpi.filter(r => r.type === "VoLTE")[0].incidents;
        const incidentsMobileData = incidentsUser.incidentsKpi.filter(r => r.type === "MobileData")[0].incidents;
        const incidentsBattery = incidentsUser.incidentsKpi.filter(r => r.type === "Battery")[0].incidents;

        incidentsRoaming.forEach(value => {
            dataCategories[0] += value.countIncident;
        });
        incidentsVoLTE.forEach(value => {
            dataCategories[1] += value.countIncident;
        });
        incidentsMobileData.forEach(value => {
            dataCategories[2] += value.countIncident;
        });
        incidentsBattery.forEach(value => {
            dataCategories[3] += value.countIncident;
        });

        incidentsRoaming.sort((a, b) => b.countIncident - a.countIncident);
        incidentsVoLTE.sort((a, b) => b.countIncident - a.countIncident);
        incidentsMobileData.sort((a, b) => b.countIncident - a.countIncident);
        incidentsBattery.sort((a, b) => b.countIncident - a.countIncident);

        let length = incidentsRoaming.length >= 5 ? 5 : incidentsRoaming.length;
        for (let i = 0; i < length; i++) {
            topRoaming.push({ name: incidentsRoaming[i].deviceId, value: incidentsRoaming[i].countIncident });
        }
        length = incidentsVoLTE.length >= 5 ? 5 : incidentsVoLTE.length;
        for (let i = 0; i < length; i++) {
            topVolte.push({ name: incidentsVoLTE[i].deviceId, value: incidentsVoLTE[i].countIncident });
        }
        length = incidentsMobileData.length >= 5 ? 5 : incidentsMobileData.length;
        for (let i = 0; i < length; i++) {
            topMobile.push({ name: incidentsMobileData[i].deviceId, value: incidentsMobileData[i].countIncident });
        }
        length = incidentsBattery.length >= 5 ? 5 : incidentsBattery.length;
        for (let i = 0; i < length; i++) {
            topBattery.push({ name: incidentsBattery[i].deviceId, value: incidentsBattery[i].countIncident });
        }
        

        console.log('incidentsRoaming: ', incidentsRoaming);
        console.log('incidentsVoLTE: ', incidentsVoLTE);
        console.log('incidentsMobileData: ', incidentsMobileData);
        console.log('dataCategories: ', dataCategories);

        setDashboardData(dataCategories)

        setTopIncidentsRoamingData(topRoaming);
        setTopIncidentsVolteData(topVolte);
        setTopIncidentsMobileData(topMobile);
        setTopIncidentsBatteryData(topBattery);
        
        setLoading(false)
    }

    const handleChangeIncidentType = e => {
        console.log('evento: ', e);
        console.log('evento: ', e.target.value);
        setIncidentType(e.target.value);
        
        if (e.target.value === 'user' || e.target.value === 'all') {
            fetchDashboardData(startDate, endDate, deviceIdList, deviceIdBrand);
            //fetchIncidentsDayData();
        } 
        if (e.target.value === 'network' || e.target.value === 'all') {
            fetchDashboardNetData(startDate, endDate, deviceIdList, deviceIdBrand);
            //fetchDashboardNetData();
            //fetchIncidentsNetDayData();
        }
        if (e.target.value === 'all') {
            setColumnsGrid(6);
        } else {
            setColumnsGrid(12);
        }
    }

    const handleDate = async date => {
        const startD = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0);
        const endD = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59);
        setStartDate(startD);
        setEndDate(endD);

        await fetchUseAppsKpi(startD, endD, deviceIdList, deviceIdBrand);

        /*
        if (incidentType === 'user' || incidentType === 'all') {
            fetchDashboardData(startD, endD, deviceIdList, deviceIdBrand);
        }
        if (incidentType === 'network' || incidentType === 'all') {
            fetchDashboardNetData(startD, endD, deviceIdList, deviceIdBrand);
        }
        */
    }

    const handleChangeDevicesBrand = async e => {
        console.log('evento: ', e);
        console.log('evento: ', e.target.value);
        
        setDeviceIdBrand(e.target.value);
        await fetchUseAppsKpi(startDate, endDate, deviceIdList, e.target.value);

        //await categoriesIncidents();
        //setDevicesBrand();
        /*
        if (incidentType === 'user' || incidentType === 'all') {
            fetchDashboardData(startDate, endDate, deviceIdList, e.target.value);
        }
        if (incidentType === 'network' || incidentType === 'all') {
            fetchDashboardNetData(startDate, endDate, deviceIdList, e.target.value);
        }
        */
    }

    const handleChangeDevicesList = async e => {
        console.log('evento: ', e.target.value);
        setDeviceIdList(e.target.value);

        await fetchUseAppsKpi(startDate, endDate, e.target.value, deviceIdBrand);

        //setDeviceIdBrand(e.target.value);
        //await categoriesIncidents();
        //setDevicesBrand();
        /*
        if (incidentType === 'user' || incidentType === 'all') {
            fetchDashboardData(startDate, endDate, e.target.value, deviceIdBrand);
        }
        if (incidentType === 'network' || incidentType === 'all') {
            fetchDashboardNetData(startDate, endDate, e.target.value, deviceIdBrand);
        }
        */
    }

    const handleChangeAccordion = () => {
        setVisiblePopover(!visiblePopover)
    }

    return (
        <div className={classes.root}>
        
            <Container maxWidth="lg" className={classes.container}> 
                { isLoading ?
                <Grid container justify = "center">
                    <CircularProgress />
                </Grid> :
                <>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                            <Accordion expanded={visiblePopover} onChange={handleChangeAccordion}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel-header"
                                >
                                    <Typography>Filters</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <InputLabel shrink id="devices-list-label">
                                            Devices list
                                        </InputLabel>
                                        <Select
                                            labelId="devices-list-label"
                                            value={deviceIdList || ''}
                                            style={{width: '90%'}}
                                            onChange={handleChangeDevicesList}
                                            displayEmpty
                                        >
                                            <MenuItem value="">
                                                <em>Select all device list</em>
                                            </MenuItem>
                                            {devicesList.map(item => (
                                                <MenuItem key={item.id} value={item.id}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <InputLabel shrink id="devices-brand-label">
                                            Devices brand
                                        </InputLabel>
                                        <Select
                                            labelId="devices-brand-label"
                                            value={deviceIdBrand || ''}
                                            style={{width: '90%'}}
                                            onChange={handleChangeDevicesBrand}
                                            displayEmpty
                                        >
                                            <MenuItem value="">
                                                <em>Select all devices brand</em>
                                            </MenuItem>
                                            {devicesBrand.map(item => (
                                                <MenuItem key={item.brand} value={item.brand}>
                                                    {item.brand}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <AccordionDetails className={classes}>
                                                <KeyboardDatePicker
                                                    id="date-picker-dialog"
                                                    label="Filter date"
                                                    format="MM/dd/yyyy"
                                                    value={startDate}
                                                    onChange={handleDate}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                />
                                            </AccordionDetails>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={3}>
                            <Paper className={fixedHeightPaper2}>
                                <Total
                                    titulo="Total Apps in use"
                                    total={totalApps}
                                    leyenda="Total Apps in use"
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Paper className={fixedHeightPaper2}>
                                <Total
                                    titulo="Total monitored devices"
                                    total={totalDevices}
                                    leyenda="Total monitored devices"
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Paper className={fixedHeightPaper2}>
                                <Total
                                    titulo="Total app usage time"
                                    total={totalTime}
                                    leyenda="Total app usage time"
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Paper className={fixedHeightPaper2}>
                                <Total
                                    titulo="Average usage time"
                                    total={totalAverage}
                                    leyenda="Average usage time"
                                />
                            </Paper>
                        </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                            <Grid item xs={12}>
                                <Paper className={fixedHeightPaper3}>
                                    <BarIncidents
                                        title={'Total time use apps'}
                                        data={totalAppsData}
                                    />
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                            <Paper className={fixedHeightPaper3}>
                                <BarTimeApps
                                    title={'Detail use Apps'}
                                    categories= {nameAppsData}
                                    data={detailUseAppsData}
                                />
                            </Paper>
                        </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                            <Paper className={fixedHeightPaper3}>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    container
                                    direction="row"
                                    justify="space-between"
                                    alignItems="center"
                                    style={{ borderBottom: '1px solid' }}
                                >
                                    <h2>Top 50 - Use app detail</h2>
                                </Grid>

                                <TableContainer>
                                    <Table
                                        className={classes.table}
                                        aria-labelledby="tableTitle"
                                        size={'medium'}
                                        aria-label="enhanced table"
                                    >
                                        <EnhancedTableHead
                                            classes={classes}
                                            numSelected={selected.length}
                                            order={order}
                                            orderBy={orderBy}
                                            //onSelectAllClick={handleSelectAllClick}
                                            //onRequestSort={handleRequestSort}
                                            rowCount={topAppsData.length}
                                        />
                                        <TableBody>
                                            {stableSort(topAppsData, getComparator(order, orderBy))
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((row, index) => {
                                                    return (
                                                        <TableRow tabIndex={-1} key={row.id}>
                                                            <TableCell>{row.nameApp || '-'}</TableCell>
                                                            <TableCell>{row.countDevices || '-'}</TableCell>
                                                            <TableCell>{row.totalTime.toFixed(2) + ' min' || '-'}</TableCell>
                                                            <TableCell>{row.minTime.toFixed(2) + ' min' || '-'}</TableCell>
                                                            <TableCell>{row.maxTime.toFixed(2) + ' min' || '-'}</TableCell>
                                                            <TableCell>{row.avgTime.toFixed(2) + ' min' || '-'}</TableCell>
                                                        </TableRow>
                                                    )
                                                })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                            </Paper>
                        </Grid>
                    </Grid>
                    
                </>
                }
                
            </Container>
        </div>
    )
}
